import React, { useState ,useEffect} from "react";
import image from "../../asserts/promotion_image.png";

import dayjs from "dayjs";
import userimg from "../../asserts/userprofile.png";
import { FaCalendar, FaPhone, FaPhoneAlt } from "react-icons/fa";
import { TbMailFilled } from "react-icons/tb";
import { Modal, Popover } from "antd";
import { faEdit, faEllipsisVertical, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Tooltip } from "antd";
import { capitalizeFirstLetter } from "../Common/Captilization";
import { useDispatch, useSelector } from "react-redux";
import { FaUsers } from "react-icons/fa";
import ReactPaginate from "react-js-pagination";
import { faChevronLeft,faChevronRight,faAngleDoubleLeft,faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { FaUser } from "react-icons/fa";
import { MdOutlineCalendarMonth } from "react-icons/md";
import  NoData from "../../asserts/no data.png";
import { GetPassengerDetails } from "../../Api/Dashboard/Dashboard";


export default function PassengerGridView({
deviceid,
  setModalIsOpen,
  SetUpdateData,
  setDeleteEmpModalIsOpen,
  setEmployeeID,
  deleteEmpmodalIsOpen

 
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [hoverid, setHoverId] = useState("");
  const [changeColor, setChangeColor] = useState();
  const [openPopovers, setOpenPopovers] = useState({});
  const [userName, setUserName] = useState("");
  const [activePage,setActivePage]=useState(1)
 const [spinning, setSpinning] = useState(false);
const getPassengerDetails =
    useSelector((state) => state.crm.passenger_details) || [];
  console.log(getPassengerDetails, "passenger details dashboard");

  const dispatch=useDispatch();

const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    let formattedDate=date.toLocaleDateString("en-GB", options);
     formattedDate = formattedDate.replace(/(\w{3}) (\d{2})$/, '$1, $2');
    return `${formattedDate}`
  };

   const formatTime = (timeStr) => {
    const date = new Date(timeStr); // directly use the full datetime string
    const options = { hour: "2-digit", minute: "2-digit", hour12: true }; // 12-hour format with AM/PM
    return date.toLocaleTimeString("en-US", options); // return as "03:50 PM"
  };


  useEffect(() => {
      // setSpinning(true);
      if (deviceid === 1) {
        console.log("BookingTable deviceId:", deviceid);
        GetPassengerDetails(dispatch, setSpinning, deviceid);
      } else if (deviceid === 2) {
        console.log("BookingTable deviceId:", deviceid);
        GetPassengerDetails(dispatch, setSpinning, deviceid);
      } else if (deviceid === 0) {
        console.log("BookingTable deviceId:", deviceid);
        GetPassengerDetails(dispatch, setSpinning, deviceid);
      }
    }, [deviceid]);

const handlePassengerChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const PassengerItemsPerPage = 10;
  const indexOfLastPassengerItem = activePage * PassengerItemsPerPage;
  const indexOfFirstPassengerItem = indexOfLastPassengerItem - PassengerItemsPerPage;
  const currentPassengerItems =
     getPassengerDetails.length > 0 &&
        getPassengerDetails?.slice(indexOfFirstPassengerItem, indexOfLastPassengerItem);
        console.log("Passenger",currentPassengerItems)




  const user = sessionStorage.getItem("USER_ID");

  const handleEdit = (tbs_passenger_id) => {
    SetUpdateData(tbs_passenger_id);
    setEmployeeID(tbs_passenger_id);
    setModalIsOpen(true);
    togglePopover(tbs_passenger_id);
  };

  const handleDelete = (tbs_passenger_id) => {
    setEmployeeID(tbs_passenger_id);
    togglePopover(tbs_passenger_id);
    setDeleteEmpModalIsOpen(true);
  };

  const togglePopover = (tbs_passenger_id) => {
    setOpenPopovers((prevState) => ({
      ...prevState,
      [tbs_passenger_id]: !prevState[tbs_passenger_id],
    }));
  };

  const closeDeleteModal = () => {
    setDeleteEmpModalIsOpen(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (event) => {
    // Get the image source (src) using `getElementById`
    const imageSrc = event.target.getAttribute('src');

    // Set the modal image source
    setModalImage(imageSrc);

    // Open the modal
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="pt-[0.5vw]">
        { currentPassengerItems?.length>0?( 
        <div className="grid grid-cols-5 w-full h-[70vh] gap-x-[3vw] gap-y-[1.1vw]">
          {currentPassengerItems?.length > 0 &&
            currentPassengerItems?.map((item) => {
              const fullname = `${item?.user_name === item?.user_name?.toLowerCase()
                              ? capitalizeFirstLetter(item?.user_name)
                              : item?.user_name}`;
              return (
                <div
                  className={`  bg-white h-[33vh] border-[#1f4b7f] border-l-[0.1vw]  border-r-[0.3vw] border-b-[0.3vw] border-t-[0.1vw] rounded-[0.5vw]`}
                  onMouseEnter={() => {
                    if (user?.startsWith("tbs-pro")) {
                      setHoverId(item.tbs_passenger_id);
                      console.log(item.tbs_passenger_id, "----owner id");
                    } else {
                      setHoverId(item.tbs_op_emp_id);
                      console.log(item.tbs_op_emp_id, "----op id");
                    }
                  }}
                  onMouseLeave={() => setHoverId("")}
                  style={{
                    transition: "ease-in 0.2s",

                    boxShadow:
                      hoverid === item.tbs_passenger_id || hoverid === item.tbs_op_emp_id
                        ? "0.5vw 0.5vw 0.5vw #1f4b7f"
                        : "none",
                  }}
                >
                 
                  <div className="flex-col h-[15vh] flex items-start justify-start gap-y-[0.6vw] mt-[0.2vw] ml-[2.5vw] mr-[2vw]">
                    <h1 className="font-bold text-[1vw] mt-[1vw] pt-[0.7vw] text-[#1f4b7f] ">
                      {/* {`${capitalizeFirstLetter(item.emp_first_name)} ${item.emp_last_name}`} */}
                      {/* {
                        fullname?.length > 17 ? <Tooltip color="white"
                          overlayInnerStyle={{ color: "#1F4B7F" }} placement="top"
                          title={`${capitalizeFirstLetter(item?.emp_first_name)} ${item.emp_last_name}`}
                          className="cursor-pointer">{fullname?.slice(0, 17) + ".."}</Tooltip> : fullname
                      } */}
                    </h1>
                    <div className="flex-col flex items-start  justify-start gap-y-[0.5vw] ">
                    {
                      item.user_name?  <h1 className="flex flex-row  space-x-[0.5vw] ">
                                      <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaUser
                            size="0.9vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                                      <div className="text-[0.9vw] text-[#1f4b7f] ">
                                        {item.user_name?.length > 15 ? (
                                          <Tooltip
                                            placement="bottom"
                                            title={item.user_name}
                                            className="cursor-pointer"
                                            color="#1F487C"
                                          >
                                            {`${item.user_name?.slice(0, 15)}...`}
                                          </Tooltip>
                                        ) : (
                                          capitalizeFirstLetter(item.user_name?.slice(0, 15))
                                        )}
                                      </div>
                                    </h1>:""
                    }
                      {
                        item.email_id?
                        <div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <TbMailFilled
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        {/* <div className="text-[0.9vw]">{item.email_id}</div> */}
                        {item?.email_id?.length > 18 ? (
                          <Tooltip
                            color="white"
                            overlayInnerStyle={{ color: "#1F4B7F" }}
                            placement="top"
                            title={item?.email_id}
                            className="cursor-pointer"
                          // color="#1F487C"
                          >
                            <div className="text-[0.9vw] text-[#1f4b7f]">
                              {" "}
                              {`${item?.email_id?.slice(0, 18)}...`}
                            </div>
                          </Tooltip>
                        ) : (
                          <div className="text-[0.9vw] text-[#1f4b7f]">
                            {/* {item?.email_id?.slice(0, 18)} */}
                            {item?.email_id === null ||item?.email_id?.slice(0, 18)}
                          </div>
                        )}
                      </div>:""
                      }
                      {
                        item.mobile_number?<div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaPhoneAlt
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        <div className="text-[0.9vw] text-[#1f4b7f]">{item?.mobile_number === null ||  item.mobile_number}</div>
                      </div>:""
                      }
                         {
                          item.occupation?
                          <div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaUsers 
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        <div className="text-[0.9vw] text-[#1f4b7f]">{item.occupation}</div>
                      </div>:<div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaUsers 
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        <div className="text-[0.9vw] text-[#1f4b7f]">General Public</div>
                      </div>
                         }
                      {
                      item.created_date?  <h1 className="flex flex-row items-center space-x-[0.5vw] ">
                                      <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaCalendar
                            size="0.9vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                                      <div className="text-[0.9vw] text-[#1f4b7f] ">
                                        {`${formatDate(item?.created_date?.slice(0, -8))} (${formatTime(item?.created_date?.slice())})`}
                                      </div>
                                    </h1>:""
                    }
                      
                      <i className="pi-ellipsis-v"></i>
                    </div>



                    



                  </div>
                  
                </div>
                
              )
            })}


            


        </div>):( <div className="grid grid-cols-1 mt-[15vw]">
          
            <div className="col-span-1 flex items-center justify-center text-gray-500">
              <img src={NoData}
            className="w-[3.5vw] h-[3.5vw] "/></div>
            <div className=" col-span-1 flex items-center justify-center font-medium text-[2vw] mt-[0.5vw] text-gray-500 ">
         No Data Found</div>
          </div>)}

        
      </div>
      

          
<div >
        {getPassengerDetails?.length > 10 && (
          <div className=" mt-[1vw]  flex justify-between items-center ">
            <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw] ">
              <span>Showing</span>
              <span className="font-bold">
                {currentPassengerItems && currentPassengerItems?.length > 0 ? (
                  <div>
                    {indexOfFirstPassengerItem + 1} -{" "}
                    {indexOfFirstPassengerItem + currentPassengerItems?.length}
                  </div>
                ) : (
                  "0"
                )}
              </span>
              <span>from</span>
              <span className="font-bold">
                {" "}
                {getPassengerDetails?.length > 0
                  ? getPassengerDetails?.length
                  : 0}
              </span>
              <span>data</span>
            </div>
            <div>
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={PassengerItemsPerPage}
                totalItemsCount={getPassengerDetails?.length}
                pageRangeDisplayed={3}
                onChange={handlePassengerChange}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                }
              />
            </div>
          </div>
        )}
      </div>
        
    </>
    
  );
}
